import React, {useContext, useEffect, useRef, useState} from 'react';
import { useLocation } from 'react-router-dom';
import login_button from '../../../assets/login_button.png';
import '../../../css/Header.css';
import { DataContext } from "../../shared/DataContext";

function Header() {
    const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
    const [showLoginMenu, setShowLoginMenu] = useState(false);
    const { currentUser } = useContext(DataContext);
    const loginMenuRef = useRef(null);
    const location = useLocation();
    const navItems = [
        { text: "Home", href: "/", divider: true },
        { text: "Directory", href: "/directory", divider: false },
        { text: "About Us", href: "/about-us", divider: true }
    ];

    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [showLoginMenu]);

    const handleOutsideClick = (event) => {
        if (loginMenuRef.current && !loginMenuRef.current.contains(event.target)) {
            setShowLoginMenu(false);
        }
    };

    const handleToggleHamburgerMenu = (event) => {
        event.preventDefault();
        if (event.target.classList.contains('hamburgerIcon')) {
            setShowHamburgerMenu(true);
        } else if (event.target.classList.contains('closeIcon')) {
            setShowHamburgerMenu(false);
        }
    };

    const handleLoginButtonClick = (event) => {
        event.preventDefault();

        setShowLoginMenu(!showLoginMenu);
    }

    return (
        <header className="header">
            <div className="headerContainer">
                <nav className="navWrapper">
                    <a href="/" className="logoLink">
                        <div className="logoContainer"/>
                    </a>
                    <div className="navLinks">
                        {navItems.map((item, index) => (
                            <a
                                key={index}
                                href={item.href}
                                className={`navLink ${location.pathname === item.href ? 'active' : ''}`}
                            >
                                {item.text}
                            </a>
                        ))}
                        <a href="/agent">
                            <button className="ctaButton">
                                CHECK IT OUT!
                            </button>
                        </a>
                        <div className="navLink">
                            <img src={login_button || ""} alt="[login menu]" className={`headerLoginButton ${showLoginMenu ? 'active' : null}`} onClick={handleLoginButtonClick} />
                        </div>
                    </div>
                    {showLoginMenu && (
                        <div className="headerLoginMenu" ref={loginMenuRef}>
                            {currentUser ? (
                                <div>
                                    <a href={currentUser.homepage}>
                                        <div className="headerLoginMenuItem">{currentUser.email}</div>
                                    </a>
                                    <a href="/logout">
                                        <div className="headerLoginMenuItem">Logout</div>
                                    </a>
                                </div>
                            ) : (
                                <div>
                                    <a href="/login">
                                        <div className="headerLoginMenuItem">Login</div>
                                    </a>
                                    <a href="/service-company-registration">
                                        <div className="headerLoginMenuItem">Sign up</div>
                                    </a>
                                </div>
                            )}
                            {currentUser?.user_type === "Admin" && (
                                <div>
                                    <div className="headerLoginMenuDivider"/>
                                    <a href="/admin/service-companies">
                                        <div className="headerLoginMenuItem">Service Companies</div>
                                    </a>
                                    <a href="/admin/contact-forms">
                                        <div className="headerLoginMenuItem">Contact Us Forms</div>
                                    </a>
                                    <a href="/admin/service-company-referrals">
                                        <div className="headerLoginMenuItem">Service Company Referrals</div>
                                    </a>
                                </div>
                            )}
                            <div className="headerLoginMenuDivider"/>
                            <a href="/coming-soon">
                                <div className="headerLoginMenuItem">Help</div>
                            </a>
                        </div>
                    )}
                    <div className={`hamburgerIcon ${showHamburgerMenu ? 'hidden' : ''}`}
                         onClick={handleToggleHamburgerMenu}/>
                    <div className={`closeIcon ${showHamburgerMenu ? '' : 'hidden'}`} onClick={handleToggleHamburgerMenu}/>
                    <div className={`hamburgerMenu ${showHamburgerMenu ? '' : 'hidden'}`}>
                        {currentUser ? (
                            <div>
                                <div className="hamburgerMenuNavLinkContainer">
                                    <a href={currentUser.homepage} className="hamburgerMenuNavLink">
                                        {currentUser.email}
                                    </a>
                                </div>
                                <div className="hamburgerMenuNavLinkContainer">
                                    <a href="/logout" className="hamburgerMenuNavLink">
                                        Logout
                                    </a>
                                </div>
                            </div>
                        ) : (
                            <div>
                                <div className="hamburgerMenuNavLinkContainer">
                                    <a href="/login" className="hamburgerMenuNavLink">
                                        Login
                                    </a>
                                </div>
                                <div className="hamburgerMenuNavLinkContainer">
                                    <a href="/service-company-registration" className="hamburgerMenuNavLink">
                                        Sign up
                                    </a>
                                </div>
                            </div>
                        )}
                        {currentUser?.user_type === "Admin" && (
                            <div>
                                <div className="headerLoginMenuDivider"/>
                                <a href="/admin/service-companies">
                                    <div className="headerLoginMenuItem">Service Companies</div>
                                </a>
                                <a href="/admin/contact-forms">
                                    <div className="headerLoginMenuItem">Contact Us Forms</div>
                                </a>
                                <a href="/admin/service-company-referrals">
                                    <div className="headerLoginMenuItem">Service Company Referrals</div>
                                </a>
                            </div>
                        )}
                        {navItems.map((item, index) => (
                            <div key={index} className="hamburgerMenuNavLinkContainer">
                            {item.divider ? <div className='hamburgerMenuNavLinkDivider'></div> : null}
                                <a
                                    href={item.href}
                                    className={`hamburgerMenuNavLink ${location.pathname === item.href ? 'active' : ''}`}
                                    onClick={() => setShowHamburgerMenu(false)}
                                >
                                    {item.text}
                                </a>
                            </div>
                        ))}
                    </div>
                </nav>
            </div>
        </header>
    );
}

export default Header;
